// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/4-ag-alumni-tag-am-arnold-gymnasium-in-neustadt-bei-coburg-2-2-2/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const p4AgAlumniTagAmArnoldGymnasiumInNeustadtBeiCoburg222DE: PageEntry = {
  id: "post.4-ag-alumni-tag-am-arnold-gymnasium-in-neustadt-bei-coburg-2-2-2",
  locale: "de",
  slug: "4-ag-alumni-tag-am-arnold-gymnasium-in-neustadt-bei-coburg-2-2-2",
  seo: {
    title: "Bei der Azubi-Gewinnung kooperieren wir mit dem lokalen Handballbundesligisten HSC 2000 | Dietz GmbH",
    description: "Bei der Azubi-Gewinnung kooperieren wir mit dem lokalen Handballbundesligisten HSC 2000",
  },
  type: "post",
  h1: "Bei der Azubi-Gewinnung kooperieren wir mit dem lokalen Handballbundesligisten HSC 2000",
  blocks: [
    { kind: "heading", level: 2, text: "Bei der Azubi-Gewinnung kooperieren wir mit dem lokalen Handballbundesligisten HSC 2000" },
    { kind: "paragraph", text: "Bei der Azubi-Gewinnung kooperieren wir mit dem lokalen Handballbundesligisten HSC 2000. Durch flexible Arbeitszeitmodelle wird so eine Ausbildung neben der Sportkarriere möglich. Mehr dazu in unserem aktuellen Recruiting-Film." }
  ],
};
